import React from "react"
import { formatDateInputValue } from "../../../utils/format"

function StepGroupName({
  name,
  eventDate,
  totalBudget,
  amountPerPerson,
  shortEventExplainer,
  showOneTimeFields = false,
  validation = {},
  invalidAttemptCount = 0,
  onChangeName,
  onChangeEventDate,
  onChangeTotalBudget,
  onChangeAmountPerPerson,
  onChangeShortEventExplainer,
}) {
  const minDate = formatDateInputValue(new Date())
  const showValidationState = invalidAttemptCount > 0
  const missingGroupName = showValidationState && !!validation?.groupName
  const missingEventDate = showValidationState && !!validation?.eventDate
  const missingTotalBudget = showValidationState && !!validation?.totalBudget
  const missingAmountPerPerson = showValidationState && !!validation?.amountPerPerson
  const missingShortEventExplainer = showValidationState && !!validation?.shortEventExplainer
  const invalidShakeClass =
    invalidAttemptCount > 0
      ? invalidAttemptCount % 2 === 0
        ? "animate-field-shake-a"
        : "animate-field-shake-b"
      : ""
  const getInputClass = (isMissing) => (
    `w-full px-3 py-2.5 border rounded-xl text-sm focus:outline-none focus:ring-2 ${
      isMissing
        ? `border-red-300 bg-red-50/40 focus:ring-red-200 ${invalidShakeClass}`
        : "border-gray-300 focus:ring-sky-300"
    }`
  )

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Step 2: Name it
        </label>
        <input
          type="text"
          value={name}
          onChange={(e) => onChangeName(e.target.value)}
          className={getInputClass(missingGroupName)}
          placeholder="Group Name"
        />
        <p className={`text-[11px] mt-1 ${missingGroupName ? "text-red-600" : "text-gray-500"}`}>
          {missingGroupName
            ? "Group name is required."
            : "Make it recognizable to members."}
        </p>
      </div>

      {showOneTimeFields && (
        <>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Event Date
            </label>
            <input
              type="date"
              value={eventDate || ""}
              onChange={(e) => onChangeEventDate(e.target.value)}
              min={minDate}
              className={getInputClass(missingEventDate)}
            />
            {missingEventDate && (
              <p className="text-[11px] text-red-600 mt-1">Event date is required.</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Total Target Amount
            </label>
            <input
              type="number"
              min="0.01"
              step="0.01"
              value={totalBudget || ""}
              onChange={(e) => onChangeTotalBudget(e.target.value)}
              className={getInputClass(missingTotalBudget)}
            />
            {missingTotalBudget && (
              <p className="text-[11px] text-red-600 mt-1">Total target amount is required.</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Per Share (Optional)
            </label>
            <input
              type="number"
              min="0.01"
              step="0.01"
              value={amountPerPerson || ""}
              onChange={(e) => onChangeAmountPerPerson(e.target.value)}
              className={getInputClass(missingAmountPerPerson)}
            />
            {missingAmountPerPerson && (
              <p className="text-[11px] text-red-600 mt-1">
                Per share must be a number greater than 0, or leave it blank.
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Short Event Explainer
            </label>
            <textarea
              rows={3}
              value={shortEventExplainer || ""}
              onChange={(e) => onChangeShortEventExplainer(e.target.value)}
              placeholder="Briefly explain the event purpose for members."
              className={`${getInputClass(missingShortEventExplainer)} resize-y`}
            />
            {missingShortEventExplainer && (
              <p className="text-[11px] text-red-600 mt-1">Short event explainer is required.</p>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default StepGroupName
